import { type KeyValueMap } from '../../../../common/keyValueMap'
import { type Truck } from '../quotes.types'

export const calculateNumberOfTrucks = (trucks: KeyValueMap<Truck, number>): number => {
  return trucks.reduce((acc, curr) => acc + curr.value, 0)
}
